<template>
  <funding-project-base :state="state">
    <portal
      v-if="state.competition.requires_collaboration_agreement_upload || state.project.conditions"
      to="tertiary"
    >
      <ul class="list-reset flex">
        <li class="mr-6">
          <a
            data-turbolinks="false"
            href="#project-contracts"
            class="block text-black no-underline hover:underline py-2"
          >
            Project Contracts
          </a>
        </li>
        <li>
          <a
            data-turbolinks="false"
            href="#additional-requirements"
            class="block text-black no-underline hover:underline py-2"
          >
            Additional Requirements
          </a>
        </li>
      </ul>
    </portal>
    <div class="container mt-8">
      <section
        id="project-contracts"
        class="flex flex-wrap"
      >
        <div class="w-full pb-6 xl:mr-12 xl:w-1/4 xl:border-b-2 flex flex-col items-start justify-start">
          <h2
            class="leading-tight text-xl"
          >
            Project Contracts
          </h2>
          <p>This projects contracts and the current status per company.</p>
          <template v-if="state.contract_template">
            <h2 class="uppercase text-xs tracking-wide text-grey-600 mt-6">
              Contract Template
            </h2>
            <p class="text-sm">
              {{ state.contract_template.title }}
            </p>
          </template>
        </div>
        <ul
          v-if="state.contracts.length"
          class="list-reset -m-6 flex-1 flex flex-wrap"
        >
          <li
            v-for="partner in state.contracts"
            :key="partner.id"
            class="w-full md:w-1/2 p-6 flex"
          >
            <funding-project-contract-card
              class="w-full"
              :partner="partner"
            />
          </li>
        </ul>
      </section>
      <section
        v-if="state.competition.requires_collaboration_agreement_upload || state.project.conditions"
        id="additional-requirements"
        class="flex flex-wrap mt-24"
      >
        <div class="w-full pb-6 xl:mr-12 xl:w-1/4 xl:border-b-2 flex flex-col items-start justify-start">
          <h2
            class="leading-tight text-xl"
          >
            Additional Requirements
          </h2>
        </div>
        <ul class="list-reset -m-6 flex-1 flex flex-wrap">
          <li
            v-if="state.competition.requires_collaboration_agreement_upload"
            class="w-full md:w-1/2 p-6 flex"
          >
            <funding-project-collaboration-agreement-card
              :project="state.project"
              :partners="state.partners"
            />
          </li>
          <li
            v-if="state.project.conditions"
            class="w-full md:w-1/2 p-6 flex"
          >
            <funding-project-conditions-card :project="state.project" />
          </li>
        </ul>
      </section>
    </div>
  </funding-project-base>
</template>
<script>
export default {
  name: "FundingProjectsContracts"
};
</script>
